var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"spacer"}),_c('b-jumbotron',{staticClass:"bg-psos ",attrs:{"header":"Not found","lead":"The requested page does not exist"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }